export class Size {
  public id: number;
  public name: string;
  public height: number;
  public width: number;

  constructor(id: number, name: string, height: number, width: number) {
    this.id = id;
    this.name = name;
    this.height = height;
    this.width = width;
  }
  /*getHeight():number {
    return this.height;
  }
  getWidth():number {
    return this.width;
  }*/
}
